import { useAtomValue } from 'jotai';
import { Routes } from '@/Routes.constants.ts';
import { mapBulkProvisioningFiltersToURLSearchParams } from '../Filters/utils/filtersToURLSearchParamsMapper.ts';
import { bulkProvisioningFiltersAtom } from 'atoms/filters/bulk-provisioning.ts';
import { useHasFeatureFlag } from 'featureFlags/useHasFeatureFlag.ts';

export const useBulkProvisioningUrlFromFilters = () => {
  const filters = useAtomValue(bulkProvisioningFiltersAtom);
  const productManagementEnabled = useHasFeatureFlag('ProductManagement');
  if (!productManagementEnabled) {
    return `${Routes.provisioningRequest}?${mapBulkProvisioningFiltersToURLSearchParams(filters)}`;
  }

  return `${Routes.simProvisioning}?${mapBulkProvisioningFiltersToURLSearchParams(filters)}`;
};
